import { ThemeOptions, createTheme } from '@mui/material/styles'

const rootElement = document.getElementById('root')
const tailwindIntegration: ThemeOptions = {
    components: {
        MuiPopover: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiPopper: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiDialog: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiModal: {
            defaultProps: {
                container: rootElement,
            },
        },
    },
}

const defaultOpt: ThemeOptions = {
    typography: {
        fontFamily: 'Roboto, sans-serif',
        fontSize: 14,
    },
    components: {
        ...tailwindIntegration.components,
        MuiButton: {
            variants: [
                {
                    style: {
                        borderRadius: '0.28rem',
                        padding: '0.5rem 1.5rem',
                    },
                    props: { variant: 'contained' },
                },
                {
                    style: {
                        borderRadius: '0.28rem',
                        padding: '0.5rem 1.5rem',
                    },
                    props: { variant: 'outlined' },
                },
                {
                    style: {
                        borderRadius: '0.28rem',
                        padding: '0.5rem 1.5rem',
                    },
                    props: { variant: 'text' },
                },
            ],
            defaultProps: {
                sx: {
                    fontSize: '0.75rem',
                },
            },
        },
        MuiIconButton: {
            defaultProps: {
                color: 'primary',
            },
        },
        MuiFilledInput: {
            defaultProps: {
                sx: {
                    borderRadius: '0.28rem',
                    backgroundColor: '#eef0f1',
                },
            },
        },
        MuiDialogTitle: {
            defaultProps: {
                color: 'text.primary',
            },
        },
        MuiTableContainer: {
            defaultProps: {
                sx: {
                    borderRadius: '0.28rem',
                },
            },
        },
        MuiTableHead: {
            defaultProps: {
                sx: {
                    backgroundColor: 'background.paper',
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    '.light &.MuiAlert-standardWarning': {
                        backgroundColor: '#f7f263',
                        color: '#181305',
                    },
                },
            },
        },
    },
}

const light = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#143a5a',
            dark: '#0b1621',
            light: '#1e4f7a',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#788b9f',
        },
        error: {
            main: '#de0f3f',
        },
        warning: {
            main: '#f2bb00',
        },
        info: {
            main: '#009cff',
        },
        success: {
            main: '#00a987',
        },
        text: {
            primary: '#060b11',
            secondary: '#0b1621',
            disabled: '#162b42',
        },
        background: {
            default: '#fcfcfc',
            paper: '#ffffff',
        },
    },
    ...defaultOpt,
})

const dark = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#788b9f',
            dark: '#ccdbea',
            light: '#1e4f7a',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#fcdc77',
        },
        error: {
            main: '#e32d57',
        },
        warning: {
            main: '#f2bb00',
        },
        info: {
            main: '#009cff',
        },
        success: {
            main: '#00a987',
        },
        text: {
            primary: '#ffffff',
            secondary: '#ffffff',
            disabled: '#c9c8c8',
        },
        background: {
            default: '#0f1a25',
            paper: '#0b1621',
        },
    },
    ...defaultOpt,
    components: {
        ...defaultOpt.components,
        MuiFilledInput: {
            defaultProps: {
                sx: {
                    ...defaultOpt?.components?.MuiFilledInput?.defaultProps?.sx,
                    backgroundColor: 'rgba(11,22,33,0.35)',
                },
            },
        },
        MuiTypography: {
            defaultProps: {
                color: 'text.primary',
            },
        },
    },
})

export default function (mode: 'light' | 'dark') {
    return mode === 'light' ? light : dark
}
